// Omnix/common/schemas/collections/omniCampaigns.js

import { z } from "zod";

const VoiceOptionsSchema = z.object({
    workflowId: z.string().min(1, "A workflow must be selected for voice campaigns."),
    concurrency: z.number().int().min(1).default(10).describe("Number of simultaneous calls to make."),
    retries: z.number().int().min(0).max(5).default(0).describe("Number of times to re-attempt a call if it fails (e.g., no answer, busy)."),
    retryInterval: z.number().int().min(1).default(60).describe("Time in seconds to wait before re-attempting a failed call.")
}).optional().nullable();

const OmniCampaignSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().optional().describe("The subscription this campaign belongs to."),
    
    name: z.string().min(1, "Campaign name is required."),
    
    type: z.enum(['message', 'voice']).default('message').describe("The type of campaign."),

    // Fields for 'message' type
    audienceId: z.string().optional().nullable(),
    templateId: z.string().optional().nullable(),
    channelConfigId: z.string().optional().nullable(),
    brandingKitId: z.string().optional().nullable().describe("The ID of the Branding Kit to use. If null, the default kit is used."), // NEW FIELD
    trackInInbox: z.boolean().default(true).describe("If true, creates/updates a conversation in the Unified Inbox for each message sent."),

    voiceOptions: VoiceOptionsSchema,

    status: z.enum(['draft', 'scheduled', 'running', 'completed', 'failed', 'cancelled']).default('draft'),
    
    scheduleType: z.enum(['now', 'later']).default('now'),
    scheduledAt: z.coerce.date().optional().nullable(),
    scheduleId: z.string().optional().nullable().describe("The _id of the task in the schedules collection."),

    stats: z.object({
        total: z.number().int().default(0),
        sent: z.number().int().default(0), // For voice, this could mean 'answered'
        failed: z.number().int().default(0),
        startedAt: z.coerce.date().optional().nullable(),
        completedAt: z.coerce.date().optional().nullable(),
    }).default({}),
    
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default OmniCampaignSchema;